import { inputValidations } from './inputValidations'

export enum DocumentTypeCodes {
    CEDULA_CIUDADANIA = 'FS0010',
    PASAPORTE_CE = 'FS0017',
    TARJETA_IDENTIDAD = 'FS0020'
}

export interface DocumentValidationRules {
    maxLength: number
    minLength: number
    pattern: RegExp
    allowedPattern: RegExp
    typeInput?: 'text' | 'number'
}

/**
 * Returns validation rules and patterns based on the document type code.
 * This ensures consistency across different forms (Registration, Guardian, etc.)
 */
export const getDocumentValidationRules = (documentType: string): DocumentValidationRules => {
    switch (documentType) {
        case DocumentTypeCodes.PASAPORTE_CE:
            return {
                minLength: 5,
                maxLength: 15,
                pattern: inputValidations.documentIdPattern,
                allowedPattern: inputValidations.documentIdPattern,
                typeInput: 'text'
            }
        case DocumentTypeCodes.CEDULA_CIUDADANIA:
            return {
                minLength: 5,
                maxLength: 11,
                pattern: inputValidations.numberPattern,
                allowedPattern: inputValidations.documentPattern,
                typeInput: 'number'
            }
        case DocumentTypeCodes.TARJETA_IDENTIDAD:
            return {
                minLength: 5,
                maxLength: 10,
                pattern: inputValidations.numberPattern,
                allowedPattern: inputValidations.documentPattern,
                typeInput: 'number'
            }
        default:
            return {
                minLength: 5,
                maxLength: 15,
                pattern: inputValidations.numberPattern,
                allowedPattern: inputValidations.documentPattern,
                typeInput: 'number'
            }
    }
}
